import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
import "./GalleryPage.css";
import NavBar from "../NavBar";
import Footer from "../Footer";
import {Videos_main} from "../../data";
import GalleryPageCards from '../../Common/GalleryPageVideoCards';



function App() {
  return <X05GalleryPageTablet {...x05GalleryPageTabletData} />;
}

export default App;

function X05GalleryPageTablet(props) {
  const {
    aboutUs,
    overlapGroup,
    latestVideos,
    text179,
    address,
    text180,
    text1802,
    text1803,
    text1804,
    frame144Props,
    antDesignplayCircleOutlined2Props,
    frame16282Props,
    frame162822Props,
    frame162823Props,
    frame162824Props,
    button22Props,
    //footer5Props,
  } = props;

  return (
    <div className="gpt-container-center-horizontal">
      <div className="gpt-x05-gallery-page-tablet screen">
        {/* <Frame144 group86Props={frame144Props.group86Props} iconMenuProps={frame144Props.iconMenuProps} /> */}
        <NavBar/>
        <h1 className="gpt-title gpt-valign-text-middle gpt-typographyheadlineh4-extrabold-24">{aboutUs}</h1>
        <div className="gpt-overlap-group" style={{ backgroundImage: `url(${Videos_main.VideoHeaderImage})` }}>  
          <div className="gpt-rectangle-78"> </div>
          <div className="gpt-frame-player">
          {/* <ReactPlayer
              url={Videos_main.VideosHeader}
              width='100%'
              height='250px'
              playIcon={<img  src={Videos_main.Play}/>}
              light={true}
              controls={true}
              playing
            /> */}
          </div>
          {/* <div className="gpt-frame-1626">
            <div className="gpt-latest-videos gpt-valign-text-middle gpt-typographybodysmall-12-regular">{latestVideos}</div>
            <div className="gpt-text-1 gpt-valign-text-middle gpt-typographyheadlineh4-extrabold-24">{text179}</div>
            <p className="gpt-address gpt-valign-text-middle gpt-typography-body-smalltext-14-regular">{address}</p>
          </div> */}
          {/* <AntDesignplayCircleOutlined22 overlapGroup1={antDesignplayCircleOutlined2Props.overlapGroup1} /> */}
        </div>
        <div className="gpt-text-2 gpt-typography-body-smalltext-14-regular">
          <p>{text180}</p>
          <p>{text1802}</p>
          <p>{text1803}</p>
          <p>{text1804}</p>
        </div>
          <GalleryPageCards />
          <Button22>{button22Props.children}</Button22>
          {/* <div className="gpt-frame-1627"> */}
          {/* <Frame162822
            youtubeCard2Props={frame16282Props.youtubeCard2Props}
            youtubeCard22Props={frame16282Props.youtubeCard22Props}
          />
          <Frame162822
            className={frame162822Props.className}
            youtubeCard2Props={frame162822Props.youtubeCard2Props}
            youtubeCard22Props={frame162822Props.youtubeCard22Props}
          />
          <Frame162822
            className={frame162823Props.className}
            youtubeCard2Props={frame162823Props.youtubeCard2Props}
            youtubeCard22Props={frame162823Props.youtubeCard22Props}
          />
          <Frame162822
            className={frame162824Props.className}
            youtubeCard2Props={frame162824Props.youtubeCard2Props}
            youtubeCard22Props={frame162824Props.youtubeCard22Props}
          /> */}
        {/* </div> */}
        {/* <Footer52 {...footer5Props} /> */}
        <Footer />
      </div>
    </div>
  );
}


function Frame144(props) {
  const { group86Props, iconMenuProps } = props;

  return (
    <div className="gpt-frame-144">
      <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
      <IconMenu vector2={iconMenuProps.vector2} vector3={iconMenuProps.vector3} />
    </div>
  );
}


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="gpt-group-86">
      <White src={whiteProps.src} />
      <img className="gpt-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="gpt-white">
      <img className="gpt-vector" src={src} />
    </div>
  );
}


function IconMenu(props) {
  const { vector2, vector3 } = props;

  return (
    <div className="gpt-icon-menu">
      <img
        className="gpt-vector-2"
        src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg"
      />
      <img className="gpt-vector-1" src={vector2} />
      <img className="gpt-vector-1" src={vector3} />
    </div>
  );
}


function AntDesignplayCircleOutlined22(props) {
  const { overlapGroup1 } = props;

  return (
    <div className="gpt-ant-designplay-circle-outlined">
      <div className="gpt-overlap-group1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
        <img
          className="gpt-vector-3"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-156@2x.svg"
        />
      </div>
    </div>
  );
}


function Frame162822(props) {
  const { className, youtubeCard2Props, youtubeCard22Props } = props;

  return (
    <div className={`gpt-frame-1628 ${className || ""}`}>
      <YoutubeCard22
        text171={youtubeCard2Props.text171}
        address={youtubeCard2Props.address}
        youtubeThumbnail2Props={youtubeCard2Props.youtubeThumbnail2Props}
      />
      <YoutubeCard22
        text171={youtubeCard22Props.text171}
        address={youtubeCard22Props.address}
        className={youtubeCard22Props.className}
        youtubeThumbnail2Props={youtubeCard22Props.youtubeThumbnail2Props}
      />
    </div>
  );
}


function YoutubeCard22(props) {
  const { text171, address, className, youtubeThumbnail2Props } = props;

  return (
    <div className={`gpt-youtube-card ${className || ""}`}>
      <YoutubeThumbnail22
        youtubeThumbnail={youtubeThumbnail2Props.youtubeThumbnail}
        overlapGroup1={youtubeThumbnail2Props.overlapGroup1}
        className={youtubeThumbnail2Props.className}
      />
      <div className="gpt-group-162">
        <div className="gpt-overlap-group1-1">
          <div className="gpt-text gpt-valign-text-middle gpt-typographyheadlineh5-extrabold-20">{text171}</div>
          <p className="gpt-address-1 gpt-valign-text-middle gpt-typographybodysmall-12-regular">{address}</p>
        </div>
      </div>
    </div>
  );
}


function YoutubeThumbnail22(props) {
  const { youtubeThumbnail, overlapGroup1, className } = props;

  return (
    <div className={`gpt-youtube-thumbnail ${className || ""}`} style={{ backgroundImage: `url(${youtubeThumbnail})` }}>
      <div className="gpt-ant-designplay-circle-outlined-1">
        <div className="gpt-overlap-group1-2" style={{ backgroundImage: `url(${overlapGroup1})` }}>
          <img
            className="gpt-vector-4"
            src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-162@2x.svg"
          />
        </div>
      </div>
    </div>
  );
}


function Button22(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(x27322191TimelineData);
  }, []);

  return (
    <div className="gpt-x27322191 gpt-component gpt-component-wrapper not-ready">
      <div className="gpt-master-button-vjylxT">
        <div className="gpt-button-i2732219151-33HRPj gpt-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const x27322191TimelineData = [
  {
    initial_state_name: "Property-1=Tertiary",
    root_element: ".gpt-x27322191",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


// function Footer52(props) {
//   const {
//     group85,
//     place,
//     overlapGroup,
//     vector2,
//     phone,
//     overlapGroup1,
//     vector3,
//     text15,
//     text14,
//     contactWebuildCom,
//     quickLinks,
//     aboutUs,
//     projects,
//     gallery,
//     knowledgeTransfer,
//     blogs,
//     faqs,
//     group872Props,
//   } = props;

//   return (
//     <div className="gpt-footer">
//       <div className="gpt-flex-row-1">
//         <img
//           className="gpt-vector-5"
//           src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-148@2x.svg"
//         />
//         <img className="gpt-group-85-1" src={group85} />
//         <Group872
//           facebookAppSymbolProps={group872Props.facebookAppSymbolProps}
//           facebookAppSymbolProps2={group872Props.facebookAppSymbolProps2}
//           twitterProps={group872Props.twitterProps}
//         />
//       </div>
//       <div className="gpt-flex-row-2">
//         <div className="gpt-group-32">
//           <div className="gpt-place gpt-valign-text-middle gpt-typographyheadlineh5-extrabold-20">{place}</div>
//           <div className="gpt-flex-row-3">
//             <div className="gpt-flex-col">
//               <div className="gpt-map-pin-1">
//                 <div className="gpt-overlap-group1-3" style={{ backgroundImage: `url(${overlapGroup})` }}>
//                   <img className="gpt-vector-6" src={vector2} />
//                 </div>
//               </div>
//               <div className="gpt-phone" style={{ backgroundImage: `url(${phone})` }}></div>
//               <div className="gpt-mail">
//                 <div className="gpt-overlap-group2" style={{ backgroundImage: `url(${overlapGroup1})` }}>
//                   <img className="gpt-vector-7" src={vector3} />
//                 </div>
//               </div>
//             </div>
//             <div className="gpt-flex-col-1">
//               <p className="gpt-text-12 gpt-typography-body-smalltext-14-regular">{text15}</p>
//               <div className="gpt-flex-col-item gpt-valign-text-middle gpt-typography-body-smalltext-14-regular">{text14}</div>
//               <div className="gpt-flex-col-item gpt-valign-text-middle gpt-typography-body-smalltext-14-regular">
//                 {contactWebuildCom}
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="gpt-group-147">
//           <div className="gpt-quick-links gpt-valign-text-middle gpt-typographyheadlineh5-extrabold-20">{quickLinks}</div>
//           <div className="gpt-flex-row-4">
//             <div className="gpt-about-us gpt-valign-text-middle gpt-typographybody16-regular">{aboutUs}</div>
//             <div className="gpt-projects gpt-valign-text-middle gpt-typographybody16-regular">{projects}</div>
//           </div>
//           <div className="gpt-flex-row">
//             <div className="gpt-gallery gpt-valign-text-middle gpt-typographybody16-regular">{gallery}</div>
//             <div className="gpt-knowledge-transfer gpt-valign-text-middle gpt-typographybody16-regular">{knowledgeTransfer}</div>
//           </div>
//           <div className="gpt-flex-row">
//             <div className="gpt-blogs gpt-valign-text-middle gpt-typographybody16-regular">{blogs}</div>
//             <div className="gpt-fa-qs gpt-valign-text-middle gpt-typographybody16-regular">{faqs}</div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


function Group872(props) {
  const { facebookAppSymbolProps, facebookAppSymbolProps2, twitterProps } = props;

  return (
    <div className="gpt-group-87">
      <FacebookAppSymbol src={facebookAppSymbolProps.src} />
      <Instagram2 overlapGroup1={facebookAppSymbolProps2.overlapGroup1} vector2={facebookAppSymbolProps2.vector2} />
      <Twitter src={twitterProps.src} />
    </div>
  );
}


function FacebookAppSymbol(props) {
  const { src } = props;

  return (
    <div className="gpt-facebook-app-symbol">
      <img className="gpt-f-1" src={src} />
    </div>
  );
}


function Instagram2(props) {
  const { overlapGroup1, vector2 } = props;

  return (
    <div className="gpt-instagram">
      <div className="gpt-overlap-group1-4" style={{ backgroundImage: `url(${overlapGroup1})` }}>
        <img
          className="gpt-vector-8"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-155@2x.svg"
        />
        <img className="gpt-vector-9" src={vector2} />
      </div>
    </div>
  );
}


function Twitter(props) {
  const { src } = props;

  return (
    <div className="gpt-twitter">
      <img className="gpt-vector-10" src={src} />
    </div>
  );
}

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/group-85-3@2x.svg",
    whiteProps: whiteData,
};

const iconMenuData = {
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
};

const frame144Data = {
    group86Props: group86Data,
    iconMenuProps: iconMenuData,
};

const antDesignplayCircleOutlined22Data = {
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-155@2x.svg",
};

const youtubeThumbnail22Data = {
    youtubeThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-18@2x.png",
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-161@2x.svg",
    className: "",
};

const youtubeCard22Data = {
    text171: "Lorem Ipsum passages of Lorem Ipsum available",
    address: "1034 Views / 24 May 2021 / 45 Comments",
    youtubeThumbnail2Props: youtubeThumbnail22Data,
};

const youtubeThumbnail222Data = {
    youtubeThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-19@2x.png",
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-161@2x.svg",
    className: "gpt-youtube-thumbnail",
};

const youtubeCard222Data = {
    text171: "Lorem Ipsum passages of Lorem Ipsum available",
    address: "1034 Views / 24 May 2021 / 45 Comments",
    className: "gpt-youtube-card-1",
    youtubeThumbnail2Props: youtubeThumbnail222Data,
};

const frame162822Data = {
    youtubeCard2Props: youtubeCard22Data,
    youtubeCard22Props: youtubeCard222Data,
};

const youtubeThumbnail223Data = {
    youtubeThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-20@2x.png",
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-161@2x.svg",
    className: "gpt-youtube-thumbnail",
};

const youtubeCard223Data = {
    text171: "Lorem Ipsum passages of Lorem Ipsum available",
    address: "1034 Views / 24 May 2021 / 45 Comments",
    youtubeThumbnail2Props: youtubeThumbnail223Data,
};

const youtubeThumbnail224Data = {
    youtubeThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-21@2x.png",
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-161@2x.svg",
    className: "gpt-youtube-thumbnail",
};

const youtubeCard224Data = {
    text171: "Lorem Ipsum passages of Lorem Ipsum available",
    address: "1034 Views / 24 May 2021 / 45 Comments",
    className: "gpt-youtube-card-1",
    youtubeThumbnail2Props: youtubeThumbnail224Data,
};

const frame1628222Data = {
    className: "gpt-frame-16",
    youtubeCard2Props: youtubeCard223Data,
    youtubeCard22Props: youtubeCard224Data,
};

const youtubeThumbnail225Data = {
    youtubeThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-22@2x.png",
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-161@2x.svg",
    className: "gpt-youtube-thumbnail",
};

const youtubeCard225Data = {
    text171: "Lorem Ipsum passages of Lorem Ipsum available",
    address: "1034 Views / 24 May 2021 / 45 Comments",
    youtubeThumbnail2Props: youtubeThumbnail225Data,
};

const youtubeThumbnail226Data = {
    youtubeThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-23@2x.png",
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-161@2x.svg",
    className: "gpt-youtube-thumbnail",
};

const youtubeCard226Data = {
    text171: "Lorem Ipsum passages of Lorem Ipsum available",
    address: "1034 Views / 24 May 2021 / 45 Comments",
    className: "gpt-youtube-card-1",
    youtubeThumbnail2Props: youtubeThumbnail226Data,
};

const frame1628223Data = {
    className: "gpt-frame-16",
    youtubeCard2Props: youtubeCard225Data,
    youtubeCard22Props: youtubeCard226Data,
};

const youtubeThumbnail227Data = {
    youtubeThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-24@2x.png",
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-161@2x.svg",
    className: "gpt-youtube-thumbnail",
};

const youtubeCard227Data = {
    text171: "Lorem Ipsum passages of Lorem Ipsum available",
    address: "1034 Views / 24 May 2021 / 45 Comments",
    youtubeThumbnail2Props: youtubeThumbnail227Data,
};

const youtubeThumbnail228Data = {
    youtubeThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-25@2x.png",
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-161@2x.svg",
    className: "gpt-youtube-thumbnail",
};

const youtubeCard228Data = {
    text171: "Lorem Ipsum passages of Lorem Ipsum available",
    address: "1034 Views / 24 May 2021 / 45 Comments",
    className: "gpt-youtube-card-1",
    youtubeThumbnail2Props: youtubeThumbnail228Data,
};

const frame1628224Data = {
    className: "gpt-frame-16",
    youtubeCard2Props: youtubeCard227Data,
    youtubeCard22Props: youtubeCard228Data,
};

const button22Data = {
    children: "VIEW MORE",
};

const facebookAppSymbolData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-1@2x.svg",
};

const instagram2Data = {
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-154@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-19@2x.svg",
};

const twitterData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-157@2x.svg",
};

const group872Data = {
    facebookAppSymbolProps: facebookAppSymbolData,
    facebookAppSymbolProps2: instagram2Data,
    twitterProps: twitterData,
};

// const footer52Data = {
//     group85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/group-85-21@2x.svg",
//     place: "Contact",
//     overlapGroup: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-20@2x.svg",
//     vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-21@2x.svg",
//     phone: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-151@2x.svg",
//     overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-152@2x.svg",
//     vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-153@2x.svg",
//     text15: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
//     text14: "+91 8976535221, +91 8755645342",
//     contactWebuildCom: "contact@webuild.com",
//     quickLinks: "Quick Links",
//     aboutUs: "About Us",
//     projects: "Projects",
//     gallery: "Gallery",
//     knowledgeTransfer: "Knowledge Transfer",
//     blogs: "Blogs",
//     faqs: "FAQ’s",
//     group872Props: group872Data,
// };

const x05GalleryPageTabletData = {
    aboutUs: "Videos",
    overlapGroup: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-76-5@1x.png",
    latestVideos: "LATEST VIDEOS",
    text179: "Lorem Ipsum passages of Lorem Ipsum available",
    address: "1034 Views / 24 May 2021 / 45 Comments",
    text180: "We are thrilled to share our videos with you here.",
    text1802: "These videos showcase our belief in transparency and quality of service. We believe that luxury does not have to mean exorbitant expense. With decades of knowledge and expertise as a third-generation family-owned fully-integrated construction firm in Bengaluru, the WeBuildd team leverages time and cost efficiencies to create properties that represent affordable luxury.",
    text1803: "Our team meticulously plans each stage of the construction process to ensure nothing challenges cost or timing decided with the client. We understand everyone has their unique expectations on what they want. With new technologies, customers are intelligent now. And we are continuously striving to fit their needs and wants. So, at WeBuildd, we are committed to bringing exceptional building solutions for our customers.",
    text1804: "The videos featured here are an engaging series of videos that showcase our previous and current projects. Browse now!",
    frame144Props: frame144Data,
    antDesignplayCircleOutlined2Props: antDesignplayCircleOutlined22Data,
    frame16282Props: frame162822Data,
    frame162822Props: frame1628222Data,
    frame162823Props: frame1628223Data,
    frame162824Props: frame1628224Data,
    button22Props: button22Data,
    //footer5Props: footer52Data,
};

